import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Form,
  Row,
  Col,
  Button,
  Select,
  Table,
  Divider,
  message,
  DatePicker,
} from "antd";
import moment from "moment";
import { fetchStatistics, fetchEaringsList } from "../../../api/earnings";
import "moment/locale/zh-cn";
import { accessToken } from "../../../utils/token";
import NProgress from "nprogress";

moment.locale("zh-cn");
const BreadCrumbData = [{ path: "/page/earnings/earnings", name: "收益" }];
const { RangePicker } = DatePicker;
const { Column } = Table;
class Earnings extends React.Component {
  state = {
    type: "",
    list: [],
    listQuery: {
      beginTime: "",
      endTime: "",
      companyName: "",
      tradeNo: "",
      pageSize: 10,
      pageNum: 1,
    },
    totalSale: 0,
    totalShare: 0,
    actualSale: 0,
    total: 0,
    statistics: {
      compareOrderNum: 0,
      compareProfit: 0,
      todayOrderNum: 0,
      todayProfit: 0,
      totalProfit: 0,
    },
  };
  async componentDidMount() {
    NProgress.start();
    await this.getStatistics();
    await this.getEarningsList();
    NProgress.done();
  }
  getEarningsList = () => {
    fetchEaringsList(this.state.listQuery).then((res) => {
      this.setState({
        list: res.data.searchResult.list,
        total: res.data.searchResult.total,
        totalSale: res.data.totalSale,
        totalShare: res.data.totalShare,
        actualSale: res.data.actualSale,
      });
    });
  };
  getStatistics = () => {
    fetchStatistics().then((res) => {
      this.setState({
        statistics: res.data,
      });
    });
  };
  dateChange = (date, dateString) => {
    this.setState({
      listQuery: {
        ...this.state.listQuery,
        beginTime: dateString[0],
        endTime: dateString[1],
      },
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (e.target.firstChild.innerText === "导 出") {
          console.log(values);
          values.tradeNo = values.tradeNo ? values.tradeNo : "";
          values.companyName = values.companyName ? values.companyName : "";
          const { listQuery } = this.state;
          // window.location.href =
          //   process.env.REACT_APP_API_PREFIX +
          //   `profit/export?${
          //     values.companyName ? `companyName=${values.companyName}&` : null
          //   }${values.tradeNo ? `tradeNo=${values.tradeNo}&` : null}beginTime=${
          //     listQuery.beginTime
          //   }&endTime=${listQuery.endTime}&accessToken=${accessToken()}`;
          window.location.href =
            process.env.REACT_APP_API_PREFIX +
            `profit/export?${`companyName=${values.companyName}&`}${`tradeNo=${values.tradeNo}&`}beginTime=${
              listQuery.beginTime
            }&endTime=${listQuery.endTime}&accessToken=${accessToken()}`;
        } else {
          this.setState(
            {
              listQuery: { ...this.state.listQuery, ...values, pageNum: 1 },
            },
            () => {
              this.getEarningsList();
              message.success("搜索成功");
            }
          );
        }
      }
    });
  };
  viewDetail = (record) => {
    return (
      <a
        onClick={() =>
          this.props.history.push(`/page/earnings/detail/${record.tradeNo}`)
        }
      >
        查看详情
      </a>
    );
  };
  renderType = (value) => {
    switch (value) {
      case "EV200":
        return "EV200";
        break;
      case "X5":
        return "X5";
        break;
      default:
        break;
    }
  };
  renderPayType = (value) => {
    switch (value) {
      case "WECHAT":
        return "微信";
        break;
      case "ALIPAY":
        return "支付宝";
        break;
      case "UNION_PAY":
        return "银联支付";
        break;
      case "NUMBER":
        return "数字货币";
        break;
      default:
        break;
    }
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      list,
      listQuery,
      total,
      statistics,
      totalSale,
      actualSale,
      totalShare,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="salesData">
          <div className="salesDataChildren">
            <div className="leftLine1"></div>
            <p className="totalMoney">总分账收益</p>
            <div className="money">￥{statistics.totalProfit}</div>
            <div className="lineBetween"></div>
            <div className="percent"> </div>
          </div>
          <div className="salesDataChildren">
            <div className="leftLine2"></div>
            <p className="totalMoney">今日分账收益</p>
            <div className="money">￥{statistics.todayProfit}</div>
            <div className="lineBetween"></div>
            <div className="percent">
              日同比{statistics.compareProfit < 0 ? "减少" : "增长"}
              {statistics.compareProfit < 0
                ? (statistics.compareProfit + "").split("-")[1]
                : statistics.compareProfit}
              %
            </div>
          </div>
          <div className="salesDataChildren">
            {" "}
            <div className="leftLine3"></div>
            <p className="totalMoney">今日订单数</p>
            <div className="money">{statistics.todayOrderNum}</div>
            <div className="lineBetween"></div>
            <div className="percent">
              日同比{statistics.compareOrderNum < 0 ? "减少" : "增长"}
              {statistics.compareOrderNum < 0
                ? (statistics.compareOrderNum + "").split("-")[1]
                : statistics.compareOrderNum}
              %
            </div>
          </div>
        </div>
        <div className="searchTitle">
          <Row>
            <Col span={20}>
              <Form layout="inline" onSubmit={this.handleSubmit}>
                <RangePicker
                  onChange={this.dateChange}
                  style={{
                    height: 40,
                    marginRight: 10,
                    paddingTop: 4,
                    width: 300,
                  }}
                />

                <Form.Item>
                  {getFieldDecorator(
                    "companyName",
                    {}
                  )(
                    <Input
                      style={{ width: 170 }}
                      placeholder="商户名称"
                      allowClear
                    />
                  )}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator(
                    "tradeNo",
                    {}
                  )(
                    <Input
                      style={{ width: 220 }}
                      placeholder="订单编号"
                      allowClear
                    />
                  )}
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    搜索
                  </Button>
                </Form.Item>
              </Form>
            </Col>
            <Col span={4} align="right">
              <Button type="primary" onClick={this.handleSubmit}>
                导出
              </Button>
            </Col>
          </Row>
          <div className="lineBetween"></div>
          <Table
            footer={() => (
              <React.Fragment>
                <span
                  style={{
                    display: "inline-block",
                    paddingLeft: 20,
                    boxSizing: "border-box",
                    width: "15%",
                  }}
                >
                  总价：
                </span>
                <span
                  style={{
                    display: "inline-block",
                    marginLeft: "47%",
                    width: "9%",
                  }}
                >
                  ￥{totalSale}
                </span>
                <span style={{ width: "9%", display: "inline-block" }}>
                  ￥{actualSale}
                </span>
                <span style={{ width: "9%" }}>￥{totalShare}</span>
              </React.Fragment>
            )}
            rowKey={(record) => record.time + Math.random()}
            dataSource={list}
            // locale={{ emptyText: "暂无商户" }}
            pagination={{
              showTotal: () => `共${total}条`,
              total: total,
              current: listQuery.pageNum,
              pageSize: listQuery.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              onChange: (page, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageNum: page },
                  },
                  () => this.getEarningsList()
                );
              },
              onShowSizeChange: (current, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageSize, pageNum: 1 },
                  },
                  () => this.getEarningsList()
                );
              },
            }}
          >
            <Column title="时间" dataIndex="time" key="time" />
            <Column
              title="商户名称"
              dataIndex="companyName"
              key="companyName"
            />
            <Column
              title="订单编号"
              dataIndex="tradeNo"
              key="tradeNo"
              render={(value) => (
                <div style={{ wordWrap: "break-word", wordBreak: "break-all" }}>
                  {value}
                </div>
              )}
            />
            <Column
              title="设备类型"
              dataIndex="capsuleType"
              key="capsuleType"
              render={this.renderType}
            />
            <Column title="设备编号" dataIndex="capsuleNo" key="capsuleNo" />
            <Column title="销售数量" dataIndex="totalNum" key="totalNum" />
            <Column
              title="支付方式"
              dataIndex="payType"
              key="payType"
              render={this.renderPayType}
            />
            <Column
              title="订单金额/元"
              dataIndex="totalPrice"
              key="totalPrice"
            />
            <Column
              title="实际销售额/元"
              dataIndex="actualPrice"
              key="actualPrice"
            />
            <Column
              title="分账收益/元"
              dataIndex="shareAmount"
              key="shareAmount"
            />
            <Column title="操作" render={this.viewDetail} />
          </Table>
        </div>
      </div>
    );
  }
}
export default Form.create()(Earnings);
